module.exports = __webpack_public_path__ + "img/vn_qrcode_fb.84559d9.png";